/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LogOut: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H10C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18H7C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6H10C10.5523 6 11 5.55228 11 5C11 4.44772 10.5523 4 10 4H7ZM16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289C14.9024 7.68342 14.9024 8.31658 15.2929 8.70711L17.5858 11L10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13L17.5858 13L15.2929 15.2929C14.9024 15.6834 14.9024 16.3166 15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071L20.7071 12.7071C20.8946 12.5196 21 12.2652 21 12C21 11.7348 20.8946 11.4804 20.7071 11.2929L16.7071 7.29289Z'
      fill='currentColor'
    />
  </React.Fragment>
)
